import { scriptInjectedFn, dataFile } from '../config';
import { liveLoaderProps } from '../components/live-loader';
const dataURLs = [
  // `${process.env.PUBLIC_URL}/data/councils-data.json`,
  `${process.env.PUBLIC_URL}/data/qld_lga_medium.geo.json`,
];

export const getCouncilData = () => {
  const url = scriptInjectedFn.getDataFileEndpoint({
    ...liveLoaderProps,
    dataset: dataFile,
    publicUrl: `${process.env.PUBLIC_URL}/data`,
  });
  return fetch(url).then((response) => response.json());
};

export const getQldCouncilGeo = () =>
  fetch(dataURLs[0]).then((response) => response.json());



// WEBPACK FOOTER //
// ./src/api/index.js